'use client';

import { WarningCircleIcon } from '@phosphor-icons/react';
import { StatusPill } from '@tranquility-ai/theme-components/status-pill';

/**
 * Filled CSAM detection label for pane/card titles (TR-3168).
 */
export function CsamDetectionPill({ type }: { type: string }) {
  return (
    <StatusPill
      color="danger"
      inverse
      size="sm"
      leadingIcon={<WarningCircleIcon size={14} weight="fill" />}
    >
      {type}
    </StatusPill>
  );
}
